$(document).ready(function(){
  (function addTopbarLinksToMobileMenu() {
    try {
      var $allLinks = $('.site-announcement .topbar-nav-wrapper .topbar-menu-item').clone().addClass('navmenu-item');
      if ($allLinks.length > 0) {
        $allLinks.find('a.topbar-menu-link').addClass('navmenu-link');
        $allLinks.appendTo($('.mobile-nav-panel .mobile-nav-content ul'));
      }
    } catch (error) {
      console.log("Error occured in addTopbarLinksToMobileMenu() at custom.js\n", error);
    }
  })();
});
